import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Dialog} from '../../../../components/common/dialogs/dialog';
import {ReportHeatMapProps} from './reportHeatMap';
import {ReportHeatMapElement} from './reportHeatmapElement';

/*
 * Const.
 */

const DIALOG_HEIGHT = 1024; // as per Figma.
const DIALOG_WIDTH = 717;

/*
 * Style.
 */

const StyledWrapperDialoagContent = styled.div`
  padding: 28px 24px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.foreground};
  height: 100%;
`;

/*
 * Props.
 */

interface ExpandedHeatmapDialogProps extends ReportHeatMapProps {
  toggleHeatmapExpanded: Handler;
}

/*
 * Component.
 * The Heatmap wrapped in a dialog.
 */

export const ExpandedHeatmapDialog: FC<ExpandedHeatmapDialogProps> = ({toggleHeatmapExpanded, ...props}) => (
  <Dialog onRequestClose={toggleHeatmapExpanded} width={DIALOG_HEIGHT} height={DIALOG_WIDTH}>
    <StyledWrapperDialoagContent>
      <ReportHeatMapElement {...props} isHeatmapExpanded onToggleHeatmapExpanded={toggleHeatmapExpanded} />
    </StyledWrapperDialoagContent>
  </Dialog>
);
